<template>
    <div
        v-if="visible"
        class="modal items-center"
        :class="{'modal-open':visible}"
    >
        <div class="modal-box p-3.5 xs:p-4 pb-0 xs:pb-0 rounded w-auto">
            <button
                v-if="step === 1"
                class="btn btn-circle btn-ghost border-0 absolute right-0 top-0"
                @click.stop="handleClose"
            >
                <SvgIcon
                    icon-name="close"
                    class="text-gray-400 w-6 h-6 cursor-pointer"
                />
            </button>
            <StepOne
                v-if="step === 1"
                @result="v => result = v"
                @isPass="nextStep"
            />
            <StepTwo
                v-else-if="step === 2"
                :result="result"
                @goTelChange="telChange"
                @goRelationship="step++"
            />
            <StepThree
                v-else-if="step === 3"
                @goTelChange="telChange"
                @result="v => result = v"
                @isPass="nextStep"
            />
            <StepFour
                v-else-if="step === 4"
                :result="result"
                @goHome="goHome"
                @close="close"
                @goConfirm="confirm"
            />
        </div>
    </div>
</template>

<script>
import { ref, nextTick, onUnmounted, watchEffect, computed } from 'vue';
import { enableScroll, disableScroll } from '@/utils/style/fixedBodyScroll';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import aplCatlCode from '@/json/aplCatlCode';
import routeName from '@/router/constant.js';
import addService from '@/utils/changeItems/addService';
import StepOne from './StepOne.vue';
import StepTwo from './StepTwo.vue';
import StepThree from './StepThree.vue';
import StepFour from './StepFour.vue';

export default {
    components: {
        StepOne,
        StepTwo,
        StepThree,
        StepFour
    },
    props: {
        postApiMid: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:postApiMid', 'confirm', 'close'],
    setup(props, { emit }) {
        const router = useRouter();
        const store = useStore();
        const aplCatl = computed(() => store.state.services.aplCatl);
        const step = ref(0);
        const visible = ref(false);
        const result = ref({});
        const nextStep = (value) => {
            /* 電話核實通過就下一頁，不通過就進入電話核實step2 */
            value ? confirm() : step.value++;
        };

        onUnmounted(() => {
            enableScroll();
        });

        watchEffect(() => {
            visible.value = props.postApiMid;
            if (visible.value) {
                nextTick(() => {
                    nextTick(() => {
                        disableScroll();
                    });
                });
                if (step.value === 0) step.value++;
            } else {
                step.value = 0;
                enableScroll();
            }
        });

        const confirm = () => {
            handleClose();
            emit('confirm');
        };

        const close = () => {
            handleClose();
            emit('close');
        };

        const handleClose = () => {
            emit('update:postApiMid', false);
        };

        const telChange = async () => {
            if (aplCatl.value === aplCatlCode.POLICY) {
                /* 如果是在640就加BC */
                const { isNext } = await addService(['BC']);
                if (isNext) router.push({ name: routeName.PROPOSER_INFO });
            } else if (aplCatl.value === aplCatlCode.CONTACT) {
                /* 如果是在631就去BD */
                router.push({ name: routeName.PROPOSER_INFO_BY_USER });
            } else {
                /* 都不是就關燈箱 */
                close();
            }
        };

        const goHome = () => {
            router.push({ name: routeName.HOME });
        };

        return {
            step,
            visible,
            result,
            confirm,
            nextStep,
            handleClose,
            close,
            telChange,
            goHome
        };
    }
};
</script>

<style lang="scss" scoped>
:deep(.modal-box) {
    @apply max-w-[96%] xs:max-w-[90%] md:max-w-[56.875rem] max-h-[95vh] relative;
    .title {
        @apply text-base xs:text-lg text-gray-900 font-bold pb-3 border-b border-gray-100 pr-7;
    }
    .content {
        @apply text-base px-0.5 py-2.5 xs:py-5 text-gray-700 w-full;
    }
    .action {
        @apply sticky bottom-0 flex flex-wrap w-full bg-white z-10 pb-3.5 xs:pb-4;
        &::before {
            content: "";
            @apply block border-t border-gray-100 w-full pb-3.5 xs:pb-4;
        }
    }
}
</style>
